// Router using https://visionmedia.github.io/page.js/
// Last Updated 2020: React, VueJS and Angular probably took over.
// Flo still likes the simplicity of this front end router
//
import page from 'page'
import { contentElementId } from '../../../config/config.js'
import { browserAppUser } from '../../../helpers/app-data-loaders/app-user.js'
import { browserAppAccount } from '../../../helpers/app-data-loaders/app-account.js'
import appStarterPg from '../../../config/app-starter-pg.js'
import { showPageGroupContactsPG } from './pg-group-contacts/index.js'
import { showPageGroupIntercompanyTransactions } from './pg-group-transactions/index.js'
import { showPageGroupAccounts } from './pg-group-accounts/index.js'
import { showPageGroupAllContacts } from './pg-group-all-contacts/index.js'

/**
 * /app/financials/interco/...
 */
export function setupIntercompanyRoutes (baseRoute) {
  /**
   * /financials/interco/:appAccountId/group-contacts
   */
  page(`${baseRoute}/:appAccountId/group-contacts`, async function (context) {
    const { appAccountId } = context.params
    await appStarterPg({
      appAccountId,
      includeEntities: true,
      includeCurrencies: true
    })

    showPageGroupContactsPG({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  /**
   * /financials/interco/:appAccountId/group-all-contacts
   */
  page(`${baseRoute}/:appAccountId/group-all-contacts`, async function (context) {
    const { appAccountId } = context.params
    await appStarterPg({
      appAccountId,
      includeEntities: true,
      includeCurrencies: true
    })

    showPageGroupAllContacts({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  /**
   * /financials/interco/:appAccountId/group-intercompany-transactions
   */
  page(`${baseRoute}/:appAccountId/group-intercompany-transactions`, async function (context) {
    const { appAccountId } = context.params
    await appStarterPg({
      appAccountId,
      includeEntities: true,
      includeCurrencies: true
    })

    showPageGroupIntercompanyTransactions({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  /**
   * /financials/interco/:appAccountId/manage-group-charts-of-accounts
   */
  page(`${baseRoute}/:appAccountId/manage-group-charts-of-accounts`, async function (context) {
    const { appAccountId } = context.params

    await appStarterPg({
      appAccountId,
      includeEntities: true
    })

    showPageGroupAccounts({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })
}
